const theme = {
  mainColor: '#00435C',
  buttonColor: '#00A1DB',
  buttonHoverColor: '#0093C7',
  bgColor: '#E4F0F5',
  black: '#000',
  white: '#fff',
  disengaged: '#808184',
  engaged: '#01A54f',
  reactive: '#e01e41',
  borderRadius: '4px' 
};

export default theme;